let language = {
    410251: "Failed to perform material mapping, and the product properties are abnormal",
};

export { language }